import { render } from "./Invited.vue?vue&type=template&id=b5f1e4f4&scoped=true&ts=true"
import script from "./Invited.vue?vue&type=script&lang=ts"
export * from "./Invited.vue?vue&type=script&lang=ts"

import "./Invited.vue?vue&type=style&index=0&id=b5f1e4f4&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f1e4f4"]])

export default __exports__